import _ from 'lodash';

const allCommands = (app, store, t) => {
  const { features } = app;

  return [
    {
      key: 'edit',
      name: t('Edit'),
      iconProps: {
        iconName: 'PageEdit',
      },
      disabled: !store.cmdBar.saleEditEnabled,
      onClick: () => store.ui.editSale(),
    },
    features.inviteSeller && {
      key: 'inviteSeller',
      name: t('Invite Seller'),
      iconProps: {
        iconName: 'ChatInviteFriend',
      },
      disabled: !store.cmdBar.inviteSellerEnabled,
      onClick: () => store.ui.inviteSeller(),
    },
    {
      key: 'messaging',
      name: t('Messaging'),
      iconProps: {
        iconName: 'Mail',
      },
      iconOnly: true,
      disabled: !store.hasSalePermissions,
      onClick: store.ui.messaging,
    },
    features.inviteBuyerAgent && {
      key: 'inviteBuyerAgent',
      name: t('Invite Buyer Agent'),
      iconProps: {
        iconName: 'ChatInviteFriend',
      },
      disabled: !store.cmdBar.inviteBuyerAgentEnabled,
      onClick: () => store.ui.inviteBuyerAgent(),
    },
    {
      key: 'preview',
      name: t('Preview'),
      iconProps: {
        iconName: 'Preview',
      },
      onClick: store.ui.showSalePreview,
    },
    {
      key: 'previewPdf',
      name: t('Blank offer'),
      iconProps: {
        iconName: 'pdf',
      },
      onClick: store.ui.showPreviewPdf,
    },
    {
      key: 'delete',
      name: t('Delete'),
      iconProps: {
        iconName: 'Delete',
      },
      disabled: !store.cmdBar.saleDeleteEnabled,
      onClick: () =>
        store.ui.prompt.open({
          title: t('Delete sale'),
          message: t('Are you sure? This action can not be undone.'),
          action: () => store.saleEdit.delete(),
        }),
    },
    {
      key: 'close',
      name: t('Close'),
      iconProps: {
        iconName: 'Stop',
      },
      disabled: !store.cmdBar.saleCloseEnabled,
      onClick: () =>
        store.ui.prompt.open({
          title: t('Close sale'),
          message: t('Are you sure to close the sale?'),
          action: () => store.saleEdit.close(),
        }),
    },
    {
      key: 'overview',
      name: t('Overview'),
      iconProps: {
        iconName: 'GroupedList',
      },
      // disabled: !store.hasSalePermissions,
      onClick: store.ui.openOverview,
    },
    {
      key: 'download',
      name: t('Download documents'),
      iconProps: {
        iconName: 'DownloadDocument',
      },
      disabled: !store.saleEdit.docs.length,
      onClick: () => window.open(`/api/v1/sales/${store.saleId}/docs`),
    },
    {
      key: 'manage',
      name: t('Manage'),
      iconProps: {
        iconName: 'PeopleRepeat',
      },
      iconOnly: true,
      onClick: store.ui.manage,
    },
    {
      key: 'notifications',
      name: t('Notifications'),
      iconProps: {
        iconName: 'MailAlert',
      },
      iconOnly: true,
      disabled: !store.hasSalePermissions,
      onClick: store.ui.notifications,
    },
    {
      key: 'auctionFinals',
      name: t('Auction Finals'),
      iconProps: {
        iconName: 'CheckList',
      },
      onClick: store.ui.auctionFinals,
    },
  ].filter(Boolean);
};

const saleCommandItems = {
  items: (app, store, t) => {
    let commands = [];
    if (store.cmdBar.whitelistingVisible) {
      commands.push({
        key: 'whitelisting',
        name: `${t('Whitelisting')}${
          store.whitelisting.pendingRequests
            ? ` (${store.whitelisting.pendingRequests})`
            : ''
        }`,
        iconProps: {
          iconName: 'MultiSelect',
        },
        iconOnly: false,
        onClick: () => store.ui.whitelisting(),
        disabled: !store.cmdBar.whitelistingEnabled,
      });
    }
    commands.push({
      key: 'settings',
      name: t('Sale wizard'),
      iconProps: {
        iconName: 'Feedback',
      },
      iconOnly: false,
      onClick: store.ui.showSaleWizard,
      disabled: !store.cmdBar.saleWizardEnabled,
    });
    return commands.filter((item) =>
      app.tenantConfig.saleCommands.includes(item.key)
    );
  },
  farItems: (app, store, t) => [
    {
      key: 'sale',
      name: t('Sale'),
      subMenuProps: {
        items: _.filter(allCommands(app, store, t), (item) =>
          app.tenantConfig.saleCommands.includes(item.key)
        ),
      },
    },
  ],
};

export { saleCommandItems };



// WEBPACK FOOTER //
// ./src/app/containers/Sale/Commands/saleCommandItems.js